<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="รายได้ของวันนี้"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0"
                    >

                    <p style="font-size: 14px">รายได้ของวันนี้</p>
                    <b>{{this.cardData.all_profit}} ฿</b>

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="รายได้รวม (หักค่าบริการ)"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0"
                    >

                    <p style="font-size: 14px">รายได้รวม (หักค่าบริการ)</p>
                    <b>{{this.cardData.promptpay_profit}} ฿</b>

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="ค่าบริการ"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                    >

                    <p style="font-size: 14px">ค่าบริการ</p>
                    <b>{{this.cardData.promptpay_service_charge}} ฿</b>

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="รายได้สุทธิ / วัน"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0"
                    >

                    <p style="font-size: 14px">รายได้สุทธิ / วัน</p>
                    <b>{{this.cardData.today_profit}} ฿</b>

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow border-0">
                        <!-- <div id="map-canvas" class="map-canvas" data-lat="40.748817" data-lng="-73.985428" style="height: 600px;"></div> -->
                        <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m8!1m3!1d86601.06593159089!2d102.84078746534277!3d16.41148633195164!3m2!1i1024!2i768!4f13.1!4m6!3e6!4m0!4m3!3m2!1d16.4668022!2d102.8198118!5e0!3m2!1sth!2sth!4v1579539740660!5m2!1sth!2sth" height="600" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import JwService from '../service/justwash';

  export default {
    data() {
      return {
        cardData: {}
      };
    },
    mounted() {
      axios({
        method: 'post',
        url: JwService.getAPI()+'/api/method/justwash.OwnerApi.Dashboard',
        data: {},
        headers: {
          'Authorization' : 'Token '+localStorage.getItem('accessToken')
        }
      }).then((response) => {
        if (response.data.message.status == true) {
          this.cardData = response.data.message.data
          // for (let idx in  response.data.message.data) {
          //   console.log(idx)
          // }
          // console.log(this.cardData);
          // console.log(response.data.message.data);
        } else {
          this.$router.push('/login')
        }
      }).catch(error => {
        console.log(error)
        this.$router.push('/login')
      });

      // let google= window.google
      // let map = document.getElementById('map-canvas');
      // let lat = map.getAttribute('data-lat');
      // let lng = map.getAttribute('data-lng');
      //
      // const myLatlng = new google.maps.LatLng(lat, lng);
      // const mapOptions = {
      //   zoom: 12,
      //   scrollwheel: false,
      //   center: myLatlng,
      //   mapTypeId: google.maps.MapTypeId.ROADMAP,
      //   styles: [
      //     {"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},
      //     {"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},
      //     {"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},
      //     {"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},
      //     {"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},
      //     {"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},
      //     {"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},
      //     {"featureType":"water","elementType":"all","stylers":[{"color":'#5e72e4'},{"visibility":"on"}]}]
      // }
      //
      // map = new google.maps.Map(map, mapOptions);
      //
      // const marker = new google.maps.Marker({
      //   position: myLatlng,
      //   map: map,
      //   animation: google.maps.Animation.DROP,
      //   title: 'Hello World!'
      // });
      //
      // const contentString = '<div class="info-window-content"><h2>Argon Dashboard</h2>' +
      //   '<p>A beautiful Dashboard for Bootstrap 4. It is Free and Open Source.</p></div>';
      //
      // const infowindow = new google.maps.InfoWindow({
      //   content: contentString
      // });
      //
      // google.maps.event.addListener(marker, 'click', function() {
      //   infowindow.open(map, marker);
      // });
    }
  };
</script>
<style>
</style>
